import { defineStore } from "pinia";
import type { LatLon } from "../search/types";
import { useSearchFocusStore } from "./searchFocus";

export const DISTANCE_ORIGIN_KEY = "eco_distance_origin";
export type DistanceOriginMode = "user" | "center";

function load(): DistanceOriginMode {
  try {
    return localStorage.getItem(DISTANCE_ORIGIN_KEY) === "center" ? "center" : "user";
  } catch {
    return "user";
  }
}

// Точка отсчёта расстояний для всего экрана поиска: позиция человека или центр карты.
export const useDistanceOriginStore = defineStore("distanceOrigin", {
  // frozenCenter - центр карты в момент открытия поиска (спека: «центр карты в
  // момент открытия поиска»): пока сессия поиска открыта, пан карты расстояния не меняет.
  // Только полноэкранный поиск телефона: на десктопе карта видна рядом с панелью,
  // и расстояния следуют за живым центром.
  state: () => ({ mode: load() as DistanceOriginMode, frozenCenter: null as LatLon | null }),
  getters: {
    canToggle: (): boolean => useSearchFocusStore().userPosition != null,
    origin(): LatLon | null {
      const f = useSearchFocusStore();
      if (this.mode === "user" && f.userPosition) return f.userPosition;
      return this.frozenCenter ?? f.mapCenter;
    },
  },
  actions: {
    // Повторный вызов (возврат в поиск из карточки) сохраняет прежний снимок.
    freezeCenter() {
      if (!this.frozenCenter) this.frozenCenter = useSearchFocusStore().mapCenter;
    },
    unfreeze() {
      this.frozenCenter = null;
    },
    toggle() {
      this.mode = this.mode === "user" ? "center" : "user";
      try {
        localStorage.setItem(DISTANCE_ORIGIN_KEY, this.mode);
      } catch {
        /* ignore */
      }
    },
  },
});
